import styled, { css } from 'styled-components';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import { transition } from '@helpers/animate';
import { h3 } from '@helpers/typography';
const Text = styled.div ``;
const PrimaryStyles = css `
  border: 1px solid ${brand.primary.beige};
  background-color: ${brand.primary.beige};
  color: ${brand.black};
  border-radius: 1000000px;

  &:hover {
    border-color: ${brand.primary.beige};
    background-color: transparent;
    color: ${brand.primary.beige};
  }

  &:active {
    border-color: ${brand.white};
    background-color: ${brand.white};
    color: ${brand.black};
  }

  &:focus {
    outline: auto;
    outline-color: currentColor;
    outline-offset: 5px;
    outline-width: thin;
  }
`;
const OutlineStyles = css `
  border: 1px solid ${brand.primary.beige};
  background-color: transparent;
  color: ${brand.primary.beige};
  border-radius: 1000000px;

  &:hover {
    border-color: ${brand.primary.beige};
    background-color: ${brand.primary.beige};
    color: ${brand.black};
  }

  &:active {
    border-color: ${brand.white};
    background-color: ${brand.white};
    color: ${brand.black};
  }

  &:focus {
    outline: auto;
    outline-color: currentColor;
    outline-offset: 5px;
    outline-width: thin;
  }
`;
const IconWrapper = styled.div `
  display: inline-block;
  vertical-align: middle;

  svg {
    max-height: 24px;
    width: 20px;
  }
`;
const Button = styled.button `
  ${transition('color, background-color, border-color')};
  display: inline-block;
  padding: 11px 25px;
  user-select: none;
  text-decoration: none;
  overflow: hidden;
  position: relative;

  ${Text} {
    ${h3};
    font-size: ${fluid(12, 14)};
    display: inline-block;
    vertical-align: middle;
    position: relative;
    text-transform: uppercase;
    z-index: 2;
    margin-bottom: 0;
  }


  ${({ branding }) => {
    switch (branding) {
        case 'solid':
            return PrimaryStyles;
        case 'outline':
            return OutlineStyles;
        default:
            break;
    }
}}


`;
export const ButtonStyles = {
    Button,
    IconWrapper,
    Text,
};
